import { theme } from "@local-logic/core/ui";
import { styled } from "styled-components";

export const ScrollContainer = styled.div`
  overflow-y: auto;
`;

export const ScoresContainer = styled.div<{ $isScoresTabExpanded: boolean }>`
  position: absolute;
  top: ${theme["--ll-spacing-medium"]};
  left: ${theme["--ll-spacing-medium"]};
  width: ${({ $isScoresTabExpanded }) =>
    $isScoresTabExpanded ? "420px" : "360px"};
  max-height: calc(100% - 2 * ${theme["--ll-spacing-medium"]});
  z-index: 1;
  border-radius: ${theme["--ll-border-radius-medium"]};
  box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 8px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${theme["--ll-color-background"]};
  border: 1px solid ${theme["--ll-color-border"]};
`;

export const AttributionContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${theme["--ll-spacing-small"]};
`;

export const TabsContainer = styled.div`
  padding: ${theme["--ll-spacing-xx-small"]};
  border-bottom: 1px solid ${theme["--ll-color-border"]};
`;
